import PlaceholderIcon from '../../../../components/transcation-list/placeholder'

export function UsersListPlaceholder() {
    return (
        <div className='flex flex-col items-center justify-center w-full h-full'>
            <PlaceholderIcon />
            <p className='mt-4 text-black'>Type something to search</p>
        </div>
    )
}
